import { useEffect } from 'react';
import { useStateful } from 'react-hanger';

import storage from '../storage';
import { formatTime } from '../utils';

const useStorage = (key: string) => {
  const cacheKey = `PC$${key}`;
  const cache = useStateful<any>(null);

  useEffect(() => {
    cache.setValue(storage.getItem(cacheKey));
  }, []);

  const setValue = (value: any) => {
    cache.setValue(value);
    storage.setItem(cacheKey, value);
  };
  return {
    value: cache.value,
    setValue,
  };
};

/**
 * 当前是否存过值
 * @param key
 */
const useStorageByDay = (key: string) => {
  const cache = useStorage(key);
  const today = useStateful<any>(null);
  useEffect(() => {
    console.log('electron storage setToday');
    today.setValue(formatTime(Date.now(), 'yyyy-MM-dd'));
  }, []);

  const setTodayCache = () => {
    cache.setValue(formatTime(Date.now(), 'yyyy-MM-dd'));
  };

  return {
    value: cache.value,
    today: today.value,
    isTodayCache: !!(cache.value && today.value && today.value === cache.value),
    setTodayCache,
  };
};

export { useStorage, useStorageByDay };
